import Overview from './Overview'
import React from 'react'

import Page from 'components/LayoutComponents/Page'

class OverviewPage extends React.Component {

  render() {
    return (
      <Page>
      	<Overview />
      </Page>
    )
  }
}

export default OverviewPage


// WEBPACK FOOTER //
// ./src/containers/OverviewPage/index.js